module.exports = __webpack_public_path__ + "static/media/pen-icon-white.18082e7d.svg";